import { useEffect, useState, useMemo } from 'react';

const isBrowser = typeof window !== 'undefined';

const screens = {
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1440
};

const screenValues = Object.values(screens);

export const useBreakpoint = (target) => {
  const [screen, setScreen] = useState(isBrowser ? window.innerWidth : 0);

  useEffect(() => {
    const setSideScreen = () => {
      setScreen(window.innerWidth);
    };
    setSideScreen();
    window.addEventListener('resize', setSideScreen);
    return () => {
      window.removeEventListener('resize', setSideScreen);
    };
  });

  const [exact, greater, lesser] = useMemo(() => {
    const targetValue = screens[target];

    const currentValue = screenValues.reduce((acc, value) => {
      if (screen >= value) {
        return value;
      }
      return acc;
    }, 0);

    return [
      currentValue === targetValue,
      screen >= targetValue,
      screen < targetValue
    ];
  }, [target, screen]);

  return {
    exact,
    greater,
    lesser
  };
};